import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"label":_vm.label ? _vm.label : 'Employee Type',"items":_vm.employeeTypeList,"item-text":"employeeType","item-value":"id","rules":[_vm.requiredCheck()],"disabled":_vm.disabled,"outlined":""},model:{value:(_vm.employeeTypeValue),callback:function ($$v) {_vm.employeeTypeValue=$$v},expression:"employeeTypeValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }